<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <rect width="64" height="64" fill="none"/>
    <g>
      <g>
        <circle class="filled" cx="37.755" cy="20.138" r="10.092" fill="currentColor"/>
        <path class="filled" d="M37.755,34.879A19.08,19.08,0,0,1,56.582,50.87a2.687,2.687,0,0,1-2.671,3.084H21.6a2.688,2.688,0,0,1-2.672-3.084A19.082,19.082,0,0,1,37.755,34.879Z" fill="currentColor"/>
      </g>
      <path class="filled" d="M9.074,33.8V32.569a1.232,1.232,0,0,1,1.232-1.233h5.663L7.744,23.112a1.232,1.232,0,0,1,0-1.742l.871-.871a1.232,1.232,0,0,1,1.743,0l8.225,8.224V23.06a1.232,1.232,0,0,1,1.232-1.232h1.232a1.233,1.233,0,0,1,1.232,1.232V33.8a1.233,1.233,0,0,1-1.232,1.232H10.306A1.232,1.232,0,0,1,9.074,33.8Z" fill="currentColor"/>
    </g>
  </g>
</svg>
